module.exports = __webpack_public_path__ + "static/media/React Icon.2c76a757.png";